import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=55312546&"
import script from "./DateComponent.vue?vue&type=script&lang=js&"
export * from "./DateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports